import initialState from './initialState';
import { reducer as saveCsvFileDataReducer } from './saveCsvFileData';
import { reducer as importItemsFromCsvDataReducer } from './importItemsFromCsvData';
import { reducer as closeImportMappingReducer } from './closeImportMapping';

const reducers = [saveCsvFileDataReducer, importItemsFromCsvDataReducer, closeImportMappingReducer];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
